webpackJsonp([261718147190374],{

/***/ 386:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Blog by Rahul Patil","subtitle":"Cloud, Bots, AI and more..","copyright":"© All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"},{"label":"Contact me","path":"/contact/"}],"author":{"name":"Rahul","email":"#","telegram":"#","twitter":"#","github":"#","rss":"#","vk":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/posts/hello-gatsby-2","categorySlug":"/categories/others/"},"frontmatter":{"title":"Hello Gatsby 2","date":"2018-10-25T12:40:32.169Z","category":"Others","description":"Test 2"}}},{"node":{"fields":{"slug":"/posts/hello-gatsby","categorySlug":"/categories/others/"},"frontmatter":{"title":"Hello Gatsby","date":"2018-10-24T12:40:32.169Z","category":"Others","description":"Test"}}}]}},"pathContext":{"category":"Others"}}

/***/ })

});


// WEBPACK FOOTER //
// path---categories-others-0d33bbbc23bdf98c98d4.js